import styled from 'styled-components';

export const StatsCont = styled.div`
  ${({ theme }) => `
    position: relative;
    display: flex;
    gap: ${theme.layout.spacing.decy};
  `};
`;
